import { RefObject } from "react";
import { ProductListEventName } from "./productListEvents";

export function dispatchCustomEvent(
  eventsRef: RefObject<HTMLElement | null>,
  type: ProductListEventName,
  detail: Record<string, unknown> = {},
) {
  const event = new CustomEvent(type, {
    detail,
    bubbles: true,
    cancelable: true,
    composed: true,
  });
  eventsRef.current?.dispatchEvent(event);
}
